import React from 'react';

const HeaderSidebar = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="header-sidebar-overlay" onClick={onClose}></div>

      <div className="header-sidebar">
        <div className="siderbar-top">
          <div className="sidebar-log">
            <a href="/" className="d-inline-flex align-items-center">
              <img
                src="/assets/img/nalexus-icon.svg"
                alt="Nalexus Technologies icon"
                style={{ width: 48, height: 'auto' }}
              />
            </a>
          </div>
          <div className="close-btn" onClick={onClose}>
            <i className="bi bi-x-lg"></i>
          </div>
        </div>

        <div className="sidebar-content">
          <p>
          Nalexus Technologies is an IT services and consultancy company launching with a clear focus: helping teams build software that scales and stays reliable as the business grows. We design and deliver SaaS products, CMS and digital experience platforms, custom enterprise applications, workflow automation and integrations, AI systems, and production-ready generative AI. Our work is grounded in practical engineering, clear delivery, and long-term maintainability, with security, observability, and clean architecture built in from the start. We partner closely with clients to turn business goals into working systems, shipped in iterative releases with transparency, accountability, and a strong focus on real operational outcomes.
          </p>
        </div>

        <div className="address-card">
          <div className="content">
            <div className="informations">
              <div className="single-info">
                <div className="icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="info">
                  <p>
                    3rd Floor, Nalexus Technologies, 12-L MM
                    Alam Rd, Gulberg, Lahore, Punjab 54600
                  </p>
                </div>
              </div>
              <div className="single-info">
                <div className="icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="info">
                  <a href="tel:+923270738451">+92 327 0738451</a>
                  <a href="tel:+923277477744">+92 327 7477744</a>
                </div>
              </div>
              <div className="single-info">
                <div className="icon">
                  <i className="far fa-envelope"></i>
                </div>
                <div className="info">
                  <a href="mailto:contact@nalexustechnologies.com">contact@nalexustechnologies.com</a>
                  <a href="mailto:career@nalexustechnologies.com">career@nalexustechnologies.com</a>                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="follow-area">
          <h5 className="blog-widget-title">Follow Us</h5>
          <p className="para">Get Company Updates</p>
          <div className="blog-widget-body">
            <ul className="follow-list d-flex flex-row align-items-start gap-4">
              <li>
                <a href="https://www.linkedin.com/company/nalexus-technologies/">
                  <i className="bx bxl-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/nalexus_technologies/">
                  <i className="bx bxl-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderSidebar;




